<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">
        During the ‘design phase’, software developers might document ideas with words or sketches
        of how a program is supposed to work, what the parts are and how it will flow.
      </p>
      <p class="mb-5">
        Imagine building a house without a plan first - it would be hard! That’s why the design
        phase of developing a program is important; it is much easier and cheaper to change sketches
        and words than written code.
      </p>
      <p class="mb-5">
        Now you will get the chance to design a game from scratch in order to understand the design
        process before computers get a look in. Let’s dive in!
      </p>

      <p class="mb-5">
        Step 1: Think of an idea for a single player video game (like Mario Bros!) and write down
        your ideas - think about these elements:
      </p>
      <ul class="default-list">
        <li>Will the game keep score?</li>
        <li>If so, what does the score represent?</li>
        <li>How do you win or level-up in the game?</li>
        <li>
          What sprites (these are the characters and objects in your projects) do you want to
          incorporate?
        </li>
      </ul>
      <p class="mb-5">
        Step 2: Think about the game flow - what does the stage look like from the first step to the
        next? Draw a rough storyboard for how you want the ‘stage’ to look.
      </p>
      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="media"
        index="1"
        key="1"
      />

      <p class="mb-5">
        Step 3: List any sprites in your game, what they do and their first position when the game
        starts.
      </p>
      <table class="table default-table">
        <tr class="header">
          <th>Sprite name</th>
          <th>What does the sprite do or represent?</th>
          <th>What is the first position when the game starts?</th>
        </tr>
        <tr class="body" v-for="index in 3" :key="index">
          <td><text-block v-model="data['question' + index + '_1']" :editable="isEditable" /></td>
          <td><text-block v-model="data['question' + index + '_2']" :editable="isEditable" /></td>
          <td><text-block v-model="data['question' + index + '_3']" :editable="isEditable" /></td>
        </tr>
      </table>
      <p class="mb-5">
        Step 4: The game may need variables to store things like the score or a timer or to track
        things.
      </p>
      <table class="table default-table">
        <tr class="header">
          <th>Variable name</th>
          <th>What is it used for?</th>
          <th>What is the initial value?</th>
          <th>What causes it to change?</th>
        </tr>
        <tr class="body" v-for="index in 3" :key="index">
          <td><text-block v-model="data['question2_' + index + '_1']" :editable="isEditable" /></td>
          <td><text-block v-model="data['question2_' + index + '_2']" :editable="isEditable" /></td>
          <td><text-block v-model="data['question2_' + index + '_3']" :editable="isEditable" /></td>
          <td><text-block v-model="data['question2_' + index + '_4']" :editable="isEditable" /></td>
        </tr>
      </table>

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
